import { Link } from 'react-router-dom';
import React from 'react';
import {
  InvoiceTaskComment,
  PaymentTaskComment,
  PurchaseOrderComment,
  PurchaseOrderContractTaskComment,
  QuotationTaskComment,
  SalesOrderComment,
  SalesOrderContractTaskComment,
  User,
} from '@/hooks/api/models';

type Props = {
  user: User;
  comment:
    | PurchaseOrderComment
    | PurchaseOrderContractTaskComment
    | SalesOrderComment
    | SalesOrderContractTaskComment
    | QuotationTaskComment
    | InvoiceTaskComment
    | PaymentTaskComment;
  onEditClick: () => void;
  onDeleteClick: () => void;
};

export const CommentMenu = (props: Props) => {
  if (props.comment.deleted) return <></>;
  if (props.user.id != props.comment.user.id) return <></>;

  return (
    <div className="dropstart ms-3">
      <Link to="" className="text-secondary text-xs" data-bs-toggle="dropdown">
        <i className="fas fa-ellipsis-v"></i>
      </Link>
      <ul className="dropdown-menu dropdown-menu-start px-2 py-3">
        <li>
          <button className="dropdown-item border-radius-md text-xs" onClick={props.onEditClick}>
            <i className="fas fa-pen me-2"></i> 編集
          </button>
        </li>
        <li>
          <button className="dropdown-item border-radius-md text-xs text-danger" onClick={props.onDeleteClick}>
            <i className="fas fa-trash-alt me-2"></i> 削除
          </button>
        </li>
      </ul>
    </div>
  );
};
